import React from 'react';
import { createRoot } from 'react-dom/client';

import StyleInjector from './StyleInjector';
import NicknameGeneratorV3 from './NicknameGenerator';

const container = document.getElementById('plarium-nickname-generator');

if (container) {
  const root = createRoot(container);
  root.render(
    <>
      <StyleInjector />
      <NicknameGeneratorV3 />
    </>,
  );
}
